/** เพลงกระบี่ร่องศิลา (lane C3 skeleton): steel + gold on stone, falling chips. Built from swordKit via families/swordArtGen.ts; polish later. */
import { makeArt } from '../families/swordArtGen';

export const NINE_FX: ReturnType<typeof makeArt> = makeArt('nine-swords', { a: 'steel', b: 'gold', motif: 'chips' }, [
  ['ns-thunder', 'qi'],
  ['ns-pierce', 'break'],
  ['ns-nine', 'qi'],
  ['ns-calm', 'heal'],
  ['ns-sweep', 'sweep', 5],
  ['ns-rush', 'lock'],
  ['ns-oath', 'buff'],
  ['ns-heaven', 'power', 5],
]);
